import { NgModule } from '@angular/core';
import { TargetBlankDirective } from '../generic-compounds/anchor/target-blank.directive';

@NgModule({
	imports: [],
	declarations: [TargetBlankDirective],
	exports: [TargetBlankDirective],
})
export class DirectivesModule { }